// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyCreateWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyCreateWebApiHandler_create,
  RentalManagerUserPropertyCreateWebApiHandler_createForSelfServeOnboarding,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  ListingType,
  PropertyType,
  UserPropertyCreateResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

interface CreateParams {
  customerId?: string;
  fullAddress: string;
  includeWebAnalytics?: boolean;
  listingType: ListingType;
  numUnits?: number;
  propertyType: PropertyType;
  unitNumber?: string;
}
interface CreateForSelfServeOnboardingParams {
  accountZrnNumber: string;
  fullAddress: string;
  listingType: ListingType;
  propertyType: PropertyType;
}

export interface RentalManagerUserPropertyCreateWebApiHandler_create_Args {
  getParams: CreateParams;
}

export type RentalManagerUserPropertyCreateWebApiHandler_create_Options = UseMutationOptions<
  UserPropertyCreateResponseWebDto,
  unknown,
  RentalManagerUserPropertyCreateWebApiHandler_create_Args
>;

/**
 * Create a property for the user
 */
export const useRentalManagerUserPropertyCreateWebApiHandler_create = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyCreateWebApiHandler_create_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyCreateWebApiHandler_create_Args) =>
      RentalManagerUserPropertyCreateWebApiHandler_create(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyCreateWebApiHandler_createForSelfServeOnboarding_Args {
  getParams: CreateForSelfServeOnboardingParams;
}

export type RentalManagerUserPropertyCreateWebApiHandler_createForSelfServeOnboarding_Options = UseMutationOptions<
  string,
  unknown,
  RentalManagerUserPropertyCreateWebApiHandler_createForSelfServeOnboarding_Args
>;

/**
 * Create a property for the user for self serve onboarding
 */
export const useRentalManagerUserPropertyCreateWebApiHandler_createForSelfServeOnboarding = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyCreateWebApiHandler_createForSelfServeOnboarding_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyCreateWebApiHandler_createForSelfServeOnboarding_Args) =>
      RentalManagerUserPropertyCreateWebApiHandler_createForSelfServeOnboarding(args.getParams, httpClient),
  });
};
